var map = {
	"./template.bet575": 1100,
	"./template.bet575.tsx": 1100,
	"./template.bet777": 1101,
	"./template.bet777.tsx": 1101,
	"./template.betprofessor": 1102,
	"./template.betprofessor.tsx": 1102,
	"./template.betroyale": 1103,
	"./template.betroyale.tsx": 1103,
	"./template.betstride": 1104,
	"./template.betstride.tsx": 1104,
	"./template.buffalobet": 1105,
	"./template.buffalobet.tsx": 1105,
	"./template.chromabet": 1106,
	"./template.chromabet.tsx": 1106,
	"./template.default": 716,
	"./template.default.tsx": 716,
	"./template.epicodds": 1107,
	"./template.epicodds.tsx": 1107,
	"./template.fiestabet": 2054,
	"./template.fiestabet.tsx": 2054,
	"./template.gigabet": 1115,
	"./template.gigabet.tsx": 1115,
	"./template.goldenbet888": 1116,
	"./template.goldenbet888.tsx": 1116,
	"./template.goldenrush": 1117,
	"./template.goldenrush.tsx": 1117,
	"./template.hyperbet": 1118,
	"./template.hyperbet.tsx": 1118,
	"./template.juicybet": 2055,
	"./template.juicybet.tsx": 2055,
	"./template.junglebet": 2056,
	"./template.junglebet.tsx": 2056,
	"./template.magnumbet": 1119,
	"./template.magnumbet.tsx": 1119,
	"./template.oldgill": 1120,
	"./template.oldgill.tsx": 1120,
	"./template.puntcity": 1121,
	"./template.puntcity.tsx": 1121,
	"./template.puntgenie": 2057,
	"./template.puntgenie.tsx": 2057,
	"./template.pyramidbet": 1122,
	"./template.pyramidbet.tsx": 1122,
	"./template.questbet": 1123,
	"./template.questbet.tsx": 1123,
	"./template.slambet": 1124,
	"./template.slambet.tsx": 1124,
	"./template.sterlingparker": 1125,
	"./template.sterlingparker.tsx": 1125,
	"./template.sugarcastle": 1126,
	"./template.sugarcastle.tsx": 1126,
	"./template.templebet": 1127,
	"./template.templebet.tsx": 1127,
	"./template.titanbet": 1128,
	"./template.titanbet.tsx": 1128,
	"./template.ts": 967,
	"./template.vikingbet": 1129,
	"./template.vikingbet.tsx": 1129,
	"./template.volcanobet": 1130,
	"./template.volcanobet.tsx": 1130,
	"./template.wellbet": 1131,
	"./template.wellbet.tsx": 1131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2425;